import Vue from 'vue';
import axios from 'axios';

const state = {
  reports: {},
  count: {},
  templates: {}
};

const actions = {
  async create ({ commit }, { data }) {
    return axios.post('/reports', data)
      .then(({ data }) => {
        return data;
      });
  },
  async get ({ commit }, { id, data }) {
    return axios.get(`/reports/${id}`, data)
      .then(({ data }) => {
        return data;
      });
  },
  async getResponses ({ commit }, { id, params }) {
    return axios.get(`/reports/${id}/responses`, { params })
      .then(({ data }) => {
        return data;
      });
  },
  async getPdf ({ commit }, { id, data }) {
    return axios.get(`/reports/${id}/pdf`, data)
      .then(({ data }) => {
        return data;
      });
  },
  async download ({ commit }, { id, params }) {
    const data = Object.assign({
      responseType: 'blob',
      params
    });
    return axios.get(`/reports/${id}/download`, data)
      .then(({ data }) => {
        return data;
      });
  },
  async update ({ commit }, { id, data }) {
    return axios.put(`/reports/${id}`, data)
      .then(({ data }) => {
        return data;
      });
  },
  async delete ({ commit }, { id }) {
    return axios.delete(`/reports/${id}`)
      .then(({ data }) => {
        return data;
      });
  },
  async deleteMany ({ commit }, { params = {} } = {}) {
    return axios.delete('/reports', { params })
      .then(({ data }) => {
        return data;
      });
  },
  async list ({ commit }, { key = 'default', params = {} }) {
    return axios.get('/reports', { params })
      .then(({ data }) => {
        commit('setList', { key, data });
        return data;
      });
  },
  async count ({ commit }, { key = 'default', params = {} }) {
    return axios.get('/reports/count', { params })
      .then(({ data }) => {
        commit('setCount', { key, data });
        return data;
      });
  },
  async templateList ({ commit }, { key = 'default', params = {} }) {
    return axios.get('/reports/templates', { params })
      .then(({ data }) => {
        commit('setTemplateList', { key, data });
        return data;
      });
  }
};

const mutations = {
  setList (state, { key = 'default', data }) {
    const reports = state.reports[key];
    Vue.set(state.reports, key, data);
  },
  setCount (state, { key = 'default', data }) {
    Vue.set(state.count, key, data);
  },
  setTemplateList (state, { key = 'default', data }) {
    if (!state.templates[key]) {
      Vue.set(state.templates, key, []);
    }
    state.templates[key].splice(0);
    state.templates[key].push(...data);
  }
};

const getters = {
  getList: (state) => (key = 'default') => {
    return state.reports[key];
  },
  getCount: (state) => (key = 'default') => {
    return state.count[key];
  },
  getTemplateList: (state) => (key = 'default') => {
    if (!state.templates[key]) {
      Vue.set(state.templates, key, []);
    }
    return state.templates[key];
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
